import axiosAuth from 'axios'

const instance = axiosAuth.create({
  baseURL: process.env.VUE_APP_API_BASEURL
})

instance.defaults.headers["Authorization"] = localStorage.getItem('token');

export default instance